import React from "react";

import { RushaSvgIcon } from "./RushaSvgIcon";

/**
 * Error status icon — X (cross) inside a circle.
 *
 * Dual-tone layered style:
 * - Circle: purple accent fill at 8%, currentColor outline
 * - X: two diagonal lines using currentColor stroke
 *
 * Used for failed / error pipeline states.
 */
export const ErrorIcon: React.FC<{ size?: number }> = ({ size = 24 }) => (
  <RushaSvgIcon size={size} fill="none">
    {/* Circle — purple accent fill at 8% */}
    <circle
      cx="12"
      cy="12"
      r="9"
      fill="#a855f7"
      fillOpacity={0.08}
      stroke="currentColor"
      strokeWidth={2}
    />
    {/* X — two diagonal lines */}
    <path
      d="M 9 9 L 15 15"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M 15 9 L 9 15"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </RushaSvgIcon>
);

ErrorIcon.displayName = "ErrorIcon";

export default ErrorIcon;
